// extracted by mini-css-extract-plugin
module.exports = {"container":"home_container__6f0H3","page1":"home_page1__3wbZI"};